import {
    CSSPathService,
    DateService,
    DocumentVisibilityTracker,
    PulseEnvironment,
} from '@pulse/browser-shared';
import {
    ProviderBuilder,
    PulseRootConfigurationToken,
    TrackerSharedConfigurations,
} from '@pulse/common';
import { PipeHost } from '../pipe';
import { PluginHost } from '../plugin';
import {
    DOMPath,
    FetchCollectorService,
    PerformanceTimelineService,
    RUMService,
    RequestMonitorService,
    XHRCollectorService,
} from '../services';
import { PipesFactory } from './pipes';
import { PluginsFactory } from './plugins';
import {
    DataLayerToken,
    DefaultPipesHostToken,
    InternalDataLayerToken,
    PipesHostToken,
} from './tokens';

//

export function trackerProviders(builder: ProviderBuilder) {
    return (
        builder
            .useFactory(TrackerSharedConfigurations, (config) => config, [
                PulseRootConfigurationToken,
            ])
            //
            // Data Layers
            ////////////////////////////
            .useFactory(
                DataLayerToken,
                (env: PulseEnvironment, config: TrackerSharedConfigurations) =>
                    (env.win as any)[config.dataLayerKey],
                [PulseEnvironment, TrackerSharedConfigurations],
            )
            .useFactory(
                InternalDataLayerToken,
                (env: PulseEnvironment) => (env.win as any).pulse?.q,
                [PulseEnvironment],
            )

            //
            // Pipe/Plugin Controller
            ////////////////////////////
            .useClass(PluginHost, PluginHost, [])
            .useClass(PipesHostToken, PipeHost, [])
            .useClass(DefaultPipesHostToken, PipeHost, [])

            //
            // RUM
            ////////////////////////////
            .useClass(RUMService, RUMService, [PerformanceTimelineService, RequestMonitorService])
            .useClass(RequestMonitorService, RequestMonitorService, [
                FetchCollectorService,
                XHRCollectorService,
                PerformanceTimelineService,
                DateService,
                PulseEnvironment,
            ])
            .useClass(CSSPathService, CSSPathService, [])
            .useClass(PerformanceTimelineService, PerformanceTimelineService, [
                PulseEnvironment,
                CSSPathService,
                DateService,
                DocumentVisibilityTracker,
            ])
            .useClass(FetchCollectorService, FetchCollectorService, [DateService, PulseEnvironment])
            .useClass(XHRCollectorService, XHRCollectorService, [DateService, PulseEnvironment])

            //
            // Factories
            ////////////////////////////
            .useClass(PluginsFactory, PluginsFactory, [TrackerSharedConfigurations, PluginHost])
            .useClass(DOMPath, DOMPath, [])
            .useClass(PipesFactory, PipesFactory, [PipesHostToken, TrackerSharedConfigurations])
    );
}
